import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";

export async function AddInvestorSessionID(user_name) {

    const Token = sessionStorage.getItem("Token");
    const accessToken = sessionStorage.getItem("access_token");
    
    const header = { "Content-Type": "application/json", Authorization: `Bearer ${Token}` };
    
    var raw = JSON.stringify({
        user_name: user_name,
        id_token: Token,
        access_token: accessToken,
    });

    var requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: header,
    };
    console.log(requestOptions)
    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
              process.env.REACT_APP_SERVER_SIDE_SESSION_API,
              requestOptions,
            );
            if (!response.ok) {
                console.log("Could not generate user session");
                return false;
            } else {
                const message = await response.json();
                if (message && message.result !== undefined && message.result !== null && message.result !== "") {
                    return message.result;
                }
                if (message && (message.advisor_id !== undefined || message.user_type !== undefined)) {
                    return message;
                }
                console.error("AddInvestorSessionID: invalid response", message);
                return false;
            }
        } catch (error) {
            if (error.name === "AbortError") {
                return 0
            }
            else {
                return 0
            }
        }
    }
    else{
        return 401
    }
}
